import { endpoints } from './constants.js';
import { post } from '@itslearning/atlas/network/fetch';

export const submitPersonData = (courseId, customerId, languageId, data) => post(
    `${endpoints.submitPersonData.replace("{courseId}", courseId)}?customerId=${customerId}&languageId=${languageId}`,
    data
);
